// 選択肢を保存
export const SELECTION_SAVE = "common/SourceSelector/SELECTION_SAVE";
// 選択肢を取得
export const SELECTION_GET = "common/SourceSelector/SELECTION_GET";
// 選択肢をクリア
export const SELECTION_CLEAR = "common/SourceSelector/SELECTION_CLEAR";
